// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import PlusCircle from "@insite/mobius/Icons/PlusCircle";
import { homeAccordionStyles } from "@steiner/App/Components/Home/HomeAccordion";
import { IconPositioner } from "@steiner/MobiusOverrides/AccordionSection/AccordionSection";
import ArrowRight from "@steiner/XDL/Icons/ArrowRight";
import MinusCircle from "@steiner/XDL/Icons/MinusCircle";
import { color, hideElementOnPrint, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

homeAccordionStyles.accordionSection = {
    headerProps: {
        css: css`
            & > button,
            & > button:focus {
                align-items: flex-start;
                background: ${color("primary")};
                padding: 12px;
                border: none;
                cursor: initial;
                ${xScreen("lte", "md")} {
                    cursor: pointer;
                    flex-direction: row-reverse;
                    gap: 12px;
                }

                ${IconPositioner} {
                    height: 21px;
                    width: 21px;
                    padding: 0;
                    max-height: initial;
                    max-width: initial;
                    top: 2px;
                }
            }
        `,
    },
    panelProps: {
        css: css`
            padding: 12px 0 0;
            border: none;
            @media print {
                display: block;
            }
        `,
    },
    expandIconProps: {
        src: PlusCircle,
        color: "common.white",
        size: 21,
    },
    collapseIconProps: {
        src: MinusCircle,
        color: "common.white",
        size: 21,
    },
};

homeAccordionStyles.headingAccordion = {
    container: {
        css: css`
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            gap: 8px 34px;
            width: 100%;
        `,
    },
    title: {
        variant: "h3",
        color: "common.white",
        css: css`
            margin-bottom: 0;
        `,
    },
    innerContainer: {
        css: css`
            display: flex;
            align-items: center;
            gap: 8px 34px;
        `,
    },
    showing: {
        size: 16,
        weight: "normal",
        color: "common.white",
        css: css`
            line-height: 19px;
            margin-left: auto;

            ${xScreen("gt", "lg")} {
                &[data-is-accordion="false"] {
                    display: none;
                }
            }

            ${xScreen("lte", "md")} {
                &[data-is-accordion="true"] {
                    display: none;
                }

                display: block;
                color: ${color("text.main")};
                padding-bottom: 12px;
            }
        `,
    },
    viewAll: {
        color: "common.white",
        icon: {
            position: "right",
            iconProps: {
                src: ArrowRight,
                color: "common.white",
                size: 16,
                css: css`
                    opacity: 0.66;
                    margin-left: 6px;
                `,
            },
        },
        css: css`
            white-space: nowrap;
            position: relative;
            &::after {
                content: "";
                position: absolute;
                left: -17px;
                background: ${color("common.white")};
                width: 1px;
                height: 30px;
                opacity: 0.66;
            }

            ${xScreen("lte", "md")} {
                &::after {
                    display: none;
                }
            }

            ${hideElementOnPrint}
        `,
    },
};
